/**
 * Company Portal / ServiceTask system status display.
 * Raw DB `service_states.name` is SK seed text (not JSON). Display via t();
 * unknown / user-defined names stay as free text.
 */

const SERVICE_STATE_NAME_KEYS = Object.freeze({
  'Vytvorený': 'ServiceState.Name.Created',
  'Čaká na schválenie': 'ServiceState.Name.WaitingApproval',
  'Čaká na kontrolu': 'ServiceState.Name.WaitingInspection',
  'Čiastočne schválený': 'ServiceState.Name.PartiallyApproved',
  'Schválený': 'ServiceState.Name.Approved',
  'Skontrolovaný': 'ServiceState.Name.Inspected',
  'Pridelený': 'ServiceState.Name.Assigned',
  'Pridelený oddeleniu': 'ServiceState.Name.AssignedDepartment',
  'V riešení': 'ServiceState.Name.InProgress',
  'Objednaný': 'ServiceState.Name.Ordered',
  'Požičaný': 'ServiceState.Name.Borrowed',
  'Rozpracovaný': 'ServiceState.Name.WorkInProgress',
  'Pracuje s obmedzením': 'ServiceState.Name.LimitedOperation',
  'Pozastavený': 'ServiceState.Name.Suspended',
  'Vrátené s poškodením': 'ServiceState.Name.ReturnedDamaged',
  'Neschválený': 'ServiceState.Name.Rejected',
  'Dodaný': 'ServiceState.Name.Delivered',
  'Odoslaný': 'ServiceState.Name.Sent',
  'Aktívny': 'ServiceState.Name.Active',
  'Porucha odstránená': 'ServiceState.Name.FaultCleared',
  'Úloha vykonaná': 'ServiceState.Name.TaskDone',
  'Povolenie zriadené': 'ServiceState.Name.PermissionGranted',
  'Odovzdaný': 'ServiceState.Name.HandedOver',
  'Hotový': 'ServiceState.Name.Ready',
  'Vrátený bez poškodenia': 'ServiceState.Name.ReturnedOk',
  'Uzavretý': 'ServiceState.Name.Closed',
  'Znovu otvoriť': 'ServiceState.Name.ReopenAction',
  'Stornovaný': 'ServiceState.Name.Cancelled',
  'Znovuotvorený': 'ServiceState.Name.Reopened',
  'Mimo prevádzky': 'ServiceState.Name.OutOfService',
});

export function serviceStateNameKey(rawName) {
  const name = String(rawName ?? '').trim();
  if (!name) return null;
  return SERVICE_STATE_NAME_KEYS[name] || null;
}

/**
 * @param {unknown} rawName
 * @param {(key: string) => string} t
 * @returns {string}
 */
export function displayServiceStateName(rawName, t) {
  const name = String(rawName ?? '').trim();
  if (!name) return '';
  const key = serviceStateNameKey(name);
  if (key && typeof t === 'function') {
    const translated = t(key);
    if (translated && translated !== key) return translated;
  }
  return name;
}

export function buildServiceStateFilterOptions(serviceStates, t, locale = 'sk') {
  return (Array.isArray(serviceStates) ? serviceStates : [])
    .map((s) => ({
      label: displayServiceStateName(s?.name, t),
      value: Number(s.id),
    }))
    .filter((o) => Number.isFinite(o.value))
    .sort((a, b) => a.label.localeCompare(b.label, locale));
}
